import { useContext, createContext, useEffect, useState } from "react";

import PropTypes from "prop-types";

import contentTypes from "@/view/constants/contentTypes";

const propTypes = {
  children: PropTypes.node,
  contentType: PropTypes.string,
  isBannerModeActive: PropTypes.bool,
};

const { INTERACTIVE_VIDEO } = contentTypes;

const PresentModeContext = createContext();

export const PresentModeContextProvider = ({
  children,
  contentType,
  isBannerModeActive,
}) => {
  const [isPresentModeActive, setIsPresentModeActive] = useState();
  const isVideo = contentType === INTERACTIVE_VIDEO;
  const [isVideoPresentModeWithoutQuiz, setPresentModeWithoutQuiz] = useState();
  const isVideoPresentModeActive = isVideo && isBannerModeActive;

  useEffect(() => {
    if (isVideoPresentModeWithoutQuiz && !isPresentModeActive) {
      setPresentModeWithoutQuiz(!isVideoPresentModeWithoutQuiz);
    }
  }, [isPresentModeActive]);

  return (
    <PresentModeContext.Provider
      value={{
        isPresentModeActive,
        isVideoPresentModeWithoutQuiz,
        isVideoPresentModeActive,
        setIsPresentModeActive,
        setPresentModeWithoutQuiz,
      }}
    >
      {children}
    </PresentModeContext.Provider>
  );
};

PresentModeContextProvider.propTypes = propTypes;

const usePresentModeContext = () => {
  const presentModeContext = useContext(PresentModeContext);

  if (presentModeContext === undefined) {
    throw new Error(
      "presentModeContext must be used within a PresentModeContextProvider.",
    );
  }

  return presentModeContext;
};

export default usePresentModeContext;
